import { render, staticRenderFns } from "./silverButton.vue?vue&type=template&id=528f7abc&scoped=true&"
import script from "./silverButton.vue?vue&type=script&lang=js&"
export * from "./silverButton.vue?vue&type=script&lang=js&"
import style0 from "./silverButton.vue?vue&type=style&index=0&id=528f7abc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528f7abc",
  null
  
)

export default component.exports